import { Link, Outlet } from 'react-router-dom'
import { LogIn } from 'lucide-react'
import { APP_NOMBRE, LOGOS } from '../../config'
import { useAuth } from '../../contexts/AuthProvider'
import { clasesBoton } from '../kit'
import { PiePlano } from './PiePlano'

/**
 * Parte pública: la barra de aplicación del kit (logo + nombre) y el pie plano. Quien
 * ya tiene sesión ve el acceso directo a la app en vez del botón de entrar.
 */
export default function PublicLayout() {
  const { user, conSesion } = useAuth()
  return (
    <div className="publico">
      <header>
        <nav className="dcc-nav-app" aria-label="Barra de la aplicación">
          <Link to="/" className="dcc-nav-app__brand publico__marca">
            <img className="dcc-logo-dcc-h" src={LOGOS.dccHorizontal} alt="DCC — Ciencias de la Computación" width={405} height={75} />
            <p className="dcc-nav-app__title">{APP_NOMBRE}</p>
          </Link>
          <div className="dcc-nav-app__user">
            {conSesion ? (
              <Link to="/app" className={clasesBoton('outlined', 'white', 'sm')}>
                Ir a la aplicación · {user?.first_name || user?.username}
              </Link>
            ) : (
              <Link to="/login" className={clasesBoton('outlined', 'white', 'sm')}>
                <LogIn className="dcc-icon dcc-i" aria-hidden /> Entrar
              </Link>
            )}
          </div>
        </nav>
      </header>
      <main className="publico__cuerpo" id="contenido">
        <Outlet />
      </main>
      <PiePlano />
    </div>
  )
}
